<script setup lang="ts">
import { AuthRegisterForm } from '@/modules/auth/components';
definePageMeta({
  layout: 'guest',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Register',
});
</script>
<template>
  <v-container class="h-screen d-flex align-center">
    <AuthRegisterForm data-testid="register-form" />
  </v-container>
</template>
<style lang="scss" scoped>
.v-form {
  width: 100%;
  max-width: 500px;
  display: inline-block;
  position: relative;
  margin: auto;
}
</style>
